<template>
  <div id="plantaddress">
    <v-row>
      <h2 class="ml-4">Plant Location</h2>
      <v-spacer></v-spacer>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text>
            <div class="general-viwe-layout">
              <h4>บริษัท กัลฟ์ เพาเวอร์ เจนเนอเรชั่น จำกัด (GPG)</h4>
              <p>เลขที่ 62 หมู่ 2 ต.บ้านป่า อ.แก่งคอย จ.สระบุรี 18110</p>
              <h4>บริษัท หนองแค โคเจนเนอเรชั่น จำกัด (NKCC)</h4>
              <p>เลขที่ 111/11 หมู่7 ต.หนองปลาหมอ อ.หนองแค จ.สระบุรี 18140</p>
              <h4>บริษัท กัลฟ์ ยะลา กรีน (GYG)</h4>
              <p>เลขที่ 80 หมู่1 ต.พร่อน อ.เมือง จ.ยะลา</p>
              <h4>บริษัท กัลฟ์ เจพี เคพี 1 จำกัด (GKP1)</h4>
              <p>เลขที่ 47 หมู่ 14 ต.โคกแย้ อ.หนองแค จ.สระบุรี 18230</p>
              <h4>บริษัท กัลฟ์ เจพี เคพี 2 จำกัด (GKP2)</h4>
              <p>เลขที่ 47/1 หมู่ 14 ต.โคกแย้ อ.หนองแค จ.สระบุรี 18230</p>
              <h4>บริษัท กัลฟ์ เจพี ทีแอลซี จำกัด (GTLC)</h4>
              <p>เลขที่ 20 หมู่ 1 ต.ตลิ่งชัน อ.เมือง จ.สระบุรี 18000</p>
              <h4>บริษัท กัลฟ์ เจพี เอ็นเอ็นเค จำกัด (GNNK)</h4>
              <p>เลขที่ 99 หมู่ 17 ต.นครเนื่องเขต อ.เมือง จ.ฉะเชิงเทรา 24000</p>
              <h4>บริษัท กัลฟ์ เจพี ซีอาร์เอ็น จำกัด (GCRN)</h4>
              <p>เลขที่ 59/4 หมู่ 4 ต.เชียงรากน้อย อ.สามโคก จ.ปทุมธานี 12160</p>
              <h4>บริษัท กัลฟ์ เจพี เอ็นแอลแอล จำกัด (GNLL)</h4>
              <p>เลขที่ 339 หมู่ 3 ต.หนองละลอก อ. บ้านค่าย จ.ระยอง 21120</p>
              <h4>บริษัท กัลฟ์ เจพี เอ็นเค 2 จำกัด (GNK2)</h4>
              <p>เลขที่ 189 หมู่ 7 ต.หนองปลาหมอ อ.หนองแค จ.สระบุรี 18140</p>
              <h4>บริษัท กัลฟ์ เจพี เอ็นเอส จำกัด (GNS)</h4>
              <p>
                เลขที่ 36 หมู่ 4 บ้านห้วยบ่า ต.หนองกบ อ.หนองแซง จ.สระบุรี 18170
              </p>
              <h4>บริษัท กัลฟ์ เจพี ยูที จำกัด (GUT)</h4>
              <p>
                เลขที่ 999 หมู่ 1 ต.บ้านช้าง อ.อุทัย จ.พระนครศรีอยุธยา 13210
              </p>
              <h4>บริษัท กัลฟ์ วีทีพี จำกัด (GVTP)</h4>
              <p>
                นิคมอุตสาหกรรม อีสเทิร์น ซีบอร์ด ซอย E10525 อ.ปลวกแดง จ.ระยอง
                21140
              </p>
              <h4>บริษัท กัลฟ์ ทีเอส1 จำกัด (GTS1)</h4>
              <p>
                นิคมอุตสาหกรรม อีสเทิร์น ซีบอร์ด ซอย E11-A อ.ปลวกแดง จ.ระยอง
                21140
              </p>
              <h4>บริษัท กัลฟ์ ทีเอส2 จำกัด (GTS2)</h4>
              <p>
                นิคมอุตสาหกรรม อีสเทิร์น ซีบอร์ด ซอย E11-A อ.ปลวกแดง จ.ระยอง
                21140
              </p>
              <h4>บริษัท กัลฟ์ ทีเอส3 จำกัด (GTS3)</h4>
              <p>นิคมอุตสาหกรรม อีสเทิร์น ซีบอร์ด อ.ปลวกแดง จ.ระยอง 21140</p>
              <h4>บริษัท กัลฟ์ ทีเอส4 จำกัด (GTS4)</h4>
              <p>นิคมอุตสาหกรรม อีสเทิร์น ซีบอร์ด อ.ปลวกแดง จ.ระยอง 21140</p>
              <h4>บริษัท กัลฟ์ เอ็นซี จำกัด (GNC)</h4>
              <p>
                เลขที่ 418 หมู่ที่ 1 ต.นนทรี อ.กบินทร์บุรี จ.ปราจีนบุรี 25110
              </p>
              <h4>บริษัท กัลฟ์ บีแอล จำกัด (GBL)</h4>
              <p>
                เลขที่ 777 หมู่ 1 นิคมอุตสาหกรรมบ้านหว้า (ไฮเทค) ต.บ้านเลน
                อ.บางประอิน จ.พระนครศรีอยุธยา 13160
              </p>
              <h4>บริษัท กัลฟ์ บีพี จำกัด (GBP)</h4>
              <p>
                เลขที่ 888 หมู่ 1 นิคมอุตสาหกรรมบ้านหว้า (ไฮเทค) ต.บ้านโพ
                อ.บางประอิน จ.พระนครศรีอยุธยา 13160
              </p>
              <h4>บริษัท กัลฟ์ เจพี เอ็นแอลแอล2 จำกัด (GNLL2)</h4>
              <p>เลขที่ 399 หมู่ 3 ต.หนองละลอก อ.บ้านค่าย จ.ระยอง 21120</p>
              <h4>บริษัท กัลฟ์ เอ็นพีเอ็ม จำกัด (GNPM)</h4>
              <p>เลขที่ 99/1 หมู่ 7 ต.หนองปลาหมอ อ.หนองแค จ.สระบุรี 18140</p>
              <h4>บริษัท กัลฟ์ เอ็นอาร์วี1 จำกัด (GNRV1)</h4>
              <p>
                เลขที่ 456 หมู่ที่ 6 ต.หนองระเวียง อ.เมืองนครราชสีมา
                จ.นครราชสีมา 30000
              </p>
              <h4>บริษัท กัลฟ์ เอ็นอาร์วี2 จำกัด (GNRV2)</h4>
              <p>เลขที่ 789 หมู่ที่ 6 ต.หนองระเวียง อ.เมืองนครราชสีมา จ.นครราชสีมา 30000</p>
              <h4>บริษัท กัลฟ์ จะนะ กรีน จำกัด (GCG)</h4>
              <p>ตำบล คู อำเภอจะนะ สงขลา 90130</p>
              <h4>บริษัท กัลฟ์ เอสอาร์ซี จำกัด (GSRC)</h4>
              <p>นิคมดับบลิวเอชเอ อีสเทิร์นซีบอร์ด ,998 หมู่ 5 ต.เขาคันทรง อ.ศรีราชา จ.ชลบุรี 20110</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.general-viwe-layout {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 1rem;
  row-gap: 0.7rem;
  width: 100%;
  @media only screen and (min-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media only screen and (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  > h4 {
    color: #103a5d;
    font-weight: 500;
    grid-column: 1/2;
    font-size: 14px;
    margin: 0;
    > span {
      color: red;
    }
    @media only screen and (min-width: 600px) {
      grid-column: 1/2;
    }
  }
  > p {
    color: #555555;
    margin: 0;
  }
  > a {
    color: #555555;
  }
  > .line {
    grid-column: 1/2;
    border-bottom: 1px solid #e5e5e5;
    @media only screen and (min-width: 600px) {
      grid-column: 1/3;
    }
  }
  > .full {
    grid-column: 1/2;
    display: grid;
    grid-template-columns: 5rem 1fr;
    @media only screen and (min-width: 600px) {
      grid-column: 1/3;
    }
    > h4 {
      color: #103a5d;
      font-weight: 500;
      grid-column: 1/2;
      font-size: 14px;
      margin: 0;
      > span {
        color: red;
      }
      @media only screen and (min-width: 600px) {
        grid-column: 1/2;
      }
    }
    > p {
      color: #555555;
      margin: 0;
      > span {
        color: #103a5d;
      }
    }
  }
}
</style>
